var render = function render(){var _vm=this,_c=_vm._self._c;return _c('router-link',{staticClass:"banner",class:{ 'banner-starforce': _vm.isTw },attrs:{"to":"/"}},[_c('SelectLanguage',{staticClass:"choose-language"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }